import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { ConfigureOutlineIcon } from '@beef/ui-kit';

import { setFiltersBarOpen } from 'store/ProductCatalog/controls/actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function FiltersButtonLayout({ isMobile, className, onClick }) {
  return (
    <div
      role="presentation"
      onClick={() => {
        onClick();
      }}
      className={cx('wrapper', className, isMobile && 'mobile')}
    >
      {!isMobile ?
        <span className={cx('text')}>Фильтры</span>
      : null}
      <ConfigureOutlineIcon size="s" className={cx('icon')} />
    </div>
  );
}

FiltersButtonLayout.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

const mapDispatchToProps = {
  onClick: setFiltersBarOpen,
};

export default connect(null, mapDispatchToProps)(FiltersButtonLayout);
